<!-- 
  新建 联系人特殊字段
  prop: 
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 客户名称 -->
    <template v-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        >
      </associated-field>
    </template>
    <!-- 客户联系人 -->
    <template v-if="item.attr === 'contactName'">
      <associated-field
        ref="associatedField"
        v-if="form.customerName.id"
        module="contactApi"
        :multiselect="false"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        >
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 供货产品 -->
    <template v-else-if="item.attr === 'products'">
      <div class="products type2">
        <input type="text" placeholder="暂无关联产品" :value="Products.productList | productLen" class="v-input" readonly>
        <div class="v-area">
          <template v-if="Products.productList.length">产品合计(元)：{{totalPrice}}；<span v-for="item in Products.surchargeList" :class="{'discount':item.surchargeType === 2}">{{item.surchargeName}}(元)：{{item.amount | fiexd}} ; </span></template>
          <template v-else>产品合计(元)：0元</template>
        </div>
        <span class="add-btn" @click="emitParent">选择</span>
      </div>
    </template>
    <!-- 决策人 -->
    <template v-if="item.attr === 'decisionMaker'">
      <!-- <div class="item-select" v-if="form.customerName">
        <span class="item" v-for="(con, i) in form[item.attr]">
          <span class="text">{{con.value}}</span>
          <i class="del el-icon-close" @click="del(i)"></i>
        </span>
        <el-button type="text" class="select-btn" @click="contactShow = !contactShow">选择</el-button>
      </div>
      <span v-else>无</span>
      <mult-select
        v-if="contactShow"
        @emitObj="saveObj"
        @close="contactShow=false"
        module="contact"
        :customerId="form.customerName.id"
        :attrValue="form[item.attr]">
      </mult-select> -->
      <associated-field
        ref="associatedField"
        v-if="form.customerName.id"
        module="contactApi"
        :multiselect="true"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        >
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 竞争对手 (竞争对手现改为文本框，以下代码暂不使用-金小瑞)-->
    <!-- <template v-if="item.attr === 'competitor'">
      <div class="item-select">
        <span class="item" v-for="(con, i) in form[item.attr]">
          <span class="text">{{con.value}}</span>
          <i class="del el-icon-close" @click="del(i)"></i>
        </span>
        <el-button type="text" class="select-btn" @click="contactShow = !contactShow">选择</el-button>
      </div>
      <mult-select
        v-if="contactShow"
        @emitObj="saveObj"
        @close="contactShow=false"
        module='customer'
        :customerId="form.customerName.id"
        :attrValue="form[item.attr]">
      </mult-select>
    </template> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import * as utils from 'src/utils'
import remoteSelect from '../remote-select'
import multSelect from 'components/modal/mult-select'
import vContact from '../contacts'
import associatedField from '../associated-field'
let initProducts = {
  'productList': [],
  'surchargeList': []
}

export default {
  props: ['item', 'form'],
  data () {
    return {
      // 选择联系人弹窗
      contactShow: false,
      Products: this.form.products || initProducts
    }
  },
  computed: {
    totalPrice () {
      console.log(this.Products.productList)
      let price = 0
      for (let i = 0; i < this.Products.productList.length; i++) {
        price = price + parseFloat(this.Products.productList[i].totalPrice || this.Products.productList[i].productPrice)
      }
      return price.toFixed(6)
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    // 重置关联信息
    changeCustomer () {
      this.form.contactName = ''
      this.form.decisionMaker = []
    },
    saveObj (obj) {
      this.form[this.item.attr] = obj
      this.setAttr(this.item.attr)
    },
    emitParent () {
      let type = 'add'
      if (this.Products.productList.length) {
        type = 'edit'
      }
      this.$emit('showProduct', type)
    },
    // 删除联系人
    del (i) {
      this.form[this.item.attr].splice(i, 1)
    },
    addNew (arr) {
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    }
  },
  components: {
    remoteSelect,
    multSelect,
    vContact,
    associatedField
  },
  filters: {
    productLen (arr) {
      if (arr && arr.length) {
        let num = 0
        arr.forEach((item) => {
          num = utils.plus(num, item.num)
        })
        return `${arr.length}种产品${num}件`
      } else {
        return ``
      }
    },
    fiexd (value) {
      return (parseFloat(value) || 0).toFixed(2)
    }
  },
  watch: {
    form: {
      handler () {
        if (this.form.products) {
          this.Products = this.form.products
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
  .products .discount {
    color: #ff6161;
  }
</style>


// WEBPACK FOOTER //
// index.vue?86ba4ff8